/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const common = {
  /**
   *  AJAX-门店搜索（最多10条）
   *  @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  searchShop(keys, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.SEARCH_SHOP,
      {
        keys: keys,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-配送中心列表
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listDistributionCenter( success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_DISTRIBUTION_CENTER_COMMON,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-搜索货品（最多10条）
   * @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  searchMaterial(keys, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.SEARCH_MATERIAL,
      {
        keys: keys,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-搜索货品（最多10条）
   * @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  searchProduceMaterial(keys,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.SEARCH_PRODUCE_MATERIAL,
      {
        keys: keys,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-供应商搜索
   *  @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  searchSupplier(keys, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.SEARCH_SUPPLIER,
      {
        keys: keys,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-根据货品id获取供应商列表
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listSupplierByMaterial(materialId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_SUPPLIER_BY_MATERIAL,
      {
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-中央厨房列表
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listKitchen(success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_KITCHENS_COMMON,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-根据供应商id获取物料
   *  @param supplierId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listMaterialBySupplier(supplierId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_MATERIAL_BY_SUPPLIER,
      {
        supplierId: supplierId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-制单人列表
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listStaff(success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_STAFF_COMMON,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取门店列表
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listShop(success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_SHOP_COMMON,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取商户列表
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listMerchant(success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_MERCHANT_COMMON,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default common;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-common.js